/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export function getProductReviewsURL(pdpURL: string) {
  return pdpURL.replace(/(^p\/)|(\/p\/)/, '/p/reviews/');
}
